import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import AuthService from '../../Authentication_usertypes/auth.service';
import './Sidebar.css';
import PopupModal from './PopupModal'; // Import the PopupModal component

const Sidebar = ({ categories, setSelectedCategory, handleCategoryClick, setSidebarOpen,
  setShowLoginPopup, CartView, setShowProfile, setShowOrders, setProduct_Details, setShowCheckout,
  handleRefundPolicy, handleTerms, categorizedProducts }) => {

  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [logo, setLogo] = useState(localStorage.getItem("system_logo"));
  const [showPopup, setShowPopup] = useState(false);
  const [popupContent, setPopupContent] = useState('');

  const filteredCategories = categories.filter(category =>
    category?.Name !== '' &&
    categorizedProducts[category._id]?.length > 0
  );

  useEffect(() => {
    const userString = localStorage.getItem('user');
    if (userString) {
      setUserData(JSON.parse(userString));
    }
  }, []);

  useEffect(() => {
    const handleEscapeKey = (event) => {
      if (event.key === 'Escape') {
        setSidebarOpen(false);
        setShowPopup(false);
      }
    };

    document.addEventListener('keydown', handleEscapeKey);

    return () => {
      document.removeEventListener('keydown', handleEscapeKey);
    };
  }, [setSidebarOpen]);

  const handleCategory = (category) => {
    setSelectedCategory(category);
    handleCategoryClick(category);
    setSidebarOpen(false);  // Close sidebar when a category is clicked
    setShowProfile(false);
    setShowOrders(false);
    setShowCheckout(false);
    setProduct_Details(null);
  };

  const handleLogout = () => {
    AuthService.logout();
    navigate('/customer_login');
  };

  const handleProfileClick = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      setShowLoginPopup(true);
      setSidebarOpen(false);  // Close sidebar when showing login popup
    } else {
      setSidebarOpen(false);
      setShowProfile(true);
      setShowOrders(false);
      setShowCheckout(false);
      setProduct_Details(null);
    }
  };

  const handleOrderClick = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      setShowLoginPopup(true);
      setSidebarOpen(false);  // Close sidebar when showing login popup
    } else {
      setSidebarOpen(false);
      setShowOrders(true);
      setShowProfile(false);
      setShowCheckout(false);
      setProduct_Details(null);
    }
  };



  return (
    <div className="sidebar-overlay" onClick={() => setSidebarOpen(false)}>
      <div className="sidebar" onClick={(e) => e.stopPropagation()}>
        <div className="sidebar-header">
          <img src={logo} alt="PHRx Logo" className="sidebar-logo" />
          <div className="sidebar-support">
            {/* <div className="support-text">Support 24/7:</div>
            <a href="tel:+1800001658" className="support-phone">+1800-001-658</a> */}
          </div>
        </div>

        <div className="sidebar-categories">
          <button
            onClick={() => handleCategory(null)}
            className="sidebar-category"
          >
            Home
          </button>
          {filteredCategories.map((category) => (
            <button
              key={category._id}
              onClick={() => handleCategory(category)}
              className="sidebar-category"
            >
              {category.Name}
            </button>
          ))}
        </div>

        <div className="sidebar-footer">
          <button onClick={handleProfileClick} className="sidebar-footer-button">
            Profile
          </button>
          <button onClick={handleOrderClick} className="sidebar-footer-button">
            My Orders
          </button>
          <button onClick={handleRefundPolicy} className="sidebar-footer-button">
            Refund Policy
          </button>
          <button onClick={handleTerms} className="sidebar-footer-button">
            Terms & Conditions
          </button>
          <button onClick={handleLogout} className="sidebar-logout-button">
            <span className="logout-icon">⇐</span> Logout
          </button>
        </div>
      </div>

      {/* Popup Modal */}
      <PopupModal show={showPopup} content={popupContent} onClose={() => setShowPopup(false)} />
    </div>
  );
};

export default Sidebar;
